<template>
  <div class="form-detail" v-if="item.supportContactInfos && item.supportContactInfos.length > 0">
    <h1>Đầu mối liên hệ</h1>
    <div class="table-responsive">
      <table class="table table-hover table-bordered">
        <thead class="thead-light">
          <tr>
            <th scope="col" class="text-left">Loại contract</th>
            <th scope="col" class="text-left">Email</th>
            <th scope="col" class="text-left">SĐT</th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in item.supportContactInfos" :key="index">
          <tr class="table-row">
            <td class="text-left">
              {{ item.code | transformData(systemConfig.tableContactInfos) }}
            </td>
            <td class="text-left">
              <span v-if="item.email"> {{ item.email }}</span>
            </td>
            <td>
              <span v-if="item.mobile"> {{ item.mobile }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        default: () => {},
      },
      systemConfig: {
        type: Object,
        default: () => {},
      },
    },
  }
</script>
